import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from "react-router-dom";
import {
    BasketProvider,
    MallProvider,
    NavProvider,
    PromptProvider, RespProvider,
    RootProvider,
    SpeechProvider,
    StoreProvider,
    UserProvider
} from "./providers";



const Providers = ({children}) =>{
    return(
        <PromptProvider>
            <RespProvider>
            <BasketProvider>
            <StoreProvider>
            <SpeechProvider>
                <NavProvider>
                    <MallProvider>
                        <UserProvider>
                            <RootProvider>
                                {children}
                            </RootProvider>
                        </UserProvider>
                    </MallProvider>
                </NavProvider>
            </SpeechProvider>
            </StoreProvider>
            </BasketProvider>
            </RespProvider>
        </PromptProvider>
    )
}


ReactDOM.render(
    <Router>
        <Providers>
            <App />
        </Providers>
    </Router>,
    document.getElementById('root')
);

if (process.env.REACT_APP_ENV === 'production') {
    console.log = () => {}
    console.error = () => {}
    console.debug = () => {}
}

serviceWorker.register();
